import React from 'react';

const ClosedMenuIcon = ({
  style = {},
  fill = '#fff',
  width = '100%',
  className = '',
  height = '100%',
  viewBox = '0 0 128 128',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M121.5,94.37h-9.87V88.12a1.75,1.75,0,0,0-1.75-1.75h-1.25V68a1.75,1.75,0,0,0-1.75-1.75H65.75V41.63H67a1.75,1.75,0,0,0,1.75-1.75V33.63h9.87a1.75,1.75,0,0,0,1.75-1.75V6.5a1.75,1.75,0,0,0-1.75-1.75H49.38A1.751,1.751,0,0,0,47.63,6.5V31.88a1.751,1.751,0,0,0,1.75,1.75h9.87v6.25A1.751,1.751,0,0,0,61,41.63h1.25V66.25H21.12A1.751,1.751,0,0,0,19.37,68V86.37H18.12a1.751,1.751,0,0,0-1.75,1.75v6.25H6.5a1.751,1.751,0,0,0-1.75,1.75V121.5a1.751,1.751,0,0,0,1.75,1.75H35.74a1.75,1.75,0,0,0,1.75-1.75V96.12a1.75,1.75,0,0,0-1.75-1.75H25.87V88.12a1.751,1.751,0,0,0-1.75-1.75H22.87V69.75H62.25V86.37H61a1.751,1.751,0,0,0-1.75,1.75v6.25H49.38a1.751,1.751,0,0,0-1.75,1.75V121.5a1.751,1.751,0,0,0,1.75,1.75H78.62a1.75,1.75,0,0,0,1.75-1.75V96.12a1.75,1.75,0,0,0-1.75-1.75H68.75V88.12A1.75,1.75,0,0,0,67,86.37H65.75V69.75h39.38V86.37h-1.25a1.75,1.75,0,0,0-1.75,1.75v6.25H92.26a1.75,1.75,0,0,0-1.75,1.75V121.5a1.75,1.75,0,0,0,1.75,1.75H121.5a1.75,1.75,0,0,0,1.75-1.75V96.12A1.75,1.75,0,0,0,121.5,94.37ZM51.13,8.25H76.87V30.13H51.13ZM65.25,33.63v4.5h-2.5v-4.5ZM33.99,119.75H8.25V97.87H33.99ZM19.87,94.37v-4.5h2.5v4.5Zm57,25.38H51.13V97.87H76.87ZM62.75,94.37v-4.5h2.5v4.5Zm42.88-4.5h2.5v4.5h-2.5Zm14.12,29.88H94.01V97.87h25.74Z"
    />
  </svg>
);

export default ClosedMenuIcon;
